var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({ref:"datePicker",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange,"blur":_vm.onBlur}},'input',{..._vm.$props, ..._vm.inputAttributes},false))
}
var staticRenderFns = []

export { render, staticRenderFns }